import React, { Component } from 'react';
import {
    View,
    StyleSheet,
    Platform
} from 'react-native';
import {
    JDText,
    JDImage,
    JDJumping,
    JDTouchable
} from '@jdreact/jdreact-core-lib';
import { pt, fenToYuan, toMap } from '../../common/utils';
import img from '../../common/img';
const isAndroid = Platform.OS === 'android';

export default class extends Component {
    onLocation = () => {
        const {
            data = {}
        } = this.props;

        toMap(data);
    }

    render() {
        const {
            data = {},
            goBuy
        } = this.props;
        const {
            cinemaName,
            address,
            cinemaDistanceStr,
            planList,
            telephoneNum,
	        planFlag = ''
        } = data;
        const planFlagNew = planFlag?.length > 8 ? planFlag?.slice(0, 8) + '...' : planFlag;
        return (
            <View style={ styles.container }>
                <View style={ styles.addressWrap }>
                    {
                        cinemaName
                            ? (
                                <View style={ [styles.row, styles.sp, styles.pr12] }>
                                    <JDTouchable
                                        onPress={ this.onLocation }
                                        style={ styles.cinema_name_wrap }
                                    >
	                                      {planFlag ? <JDText style={styles.plan}>{planFlagNew}</JDText>: <></>}
                                        <View style={ [styles.row, styles.mb6, styles.cinema_name] }>
                                            <JDText style={ styles.name }>{ cinemaName || ''}</JDText>
                                            <JDImage
                                                style={ styles.img }
                                                source={ { uri: 'https://img13.360buyimg.com/imagetools/jfs/t1/277696/32/10520/560/67e3d29fFeaeb2313/645984b608a9867e.png' } }
                                            />
                                        </View>
                                    </JDTouchable>
                                    {
                                        telephoneNum
                                            ? (

                                                <a href={ 'tel:' + telephoneNum }>
                                                    <JDImage style={ styles.tel } source={ img.tel } />
                                                </a>
                                            )
                                            : null
                                    }
                                </View>
                            )
                            : null
                    }
                    <View style={ [styles.row, styles.sp, styles.pr15] }>
                        <JDText style={ styles.gray }>{address || ''}</JDText>
                        <JDText type="regular" style={ styles.gray }>{ cinemaDistanceStr || ''}</JDText>
                    </View>
                </View>
                {
                    planList?.map((item, index) => {
                        const [priceQian, priceHou] = fenToYuan(item?.jdPrice)?.split('.');

                        return (
                            <View
                                key={ index }
                                style={ [styles.row, styles.sp, styles.planWrap] }
                            >
                                <View
                                    style={ [styles.row, styles.baseline] }
                                >
                                    <View style={ [styles.column, styles.start, styles.mr25] }>
                                        <JDText type="regular" style={ [styles.font1, styles.mb6] }>{item?.startTime || ''}</JDText>
                                        <JDText style={ styles.gray }>{item?.endTime || ''} 散场</JDText>
                                    </View>
                                    <View style={ [styles.column, styles.start] }>
                                        <JDText style={ [styles.font2, styles.mb6] } numberOfLines={ 1 } >{ item?.type || ''}</JDText>
                                        <JDText style={ [styles.gray, { width: pt(80) }] } numberOfLines={ 1 }>{item?.hallName || ''}</JDText>
                                    </View>
                                </View>

                                <View
                                    style={ styles.row }
                                >
                                    <View style={ [styles.column, styles.end, { paddingTop: pt(9) }, styles.mr14] }>
                                        {
                                            (item?.joinTicketNum >= item?.minTicketNum)
                                                ? (
                                                    <>
                                                        <View style={ [styles.row, styles.mb6] }>
                                                            <JDImage
                                                                style={ styles.img2 }
                                                                source={ { uri: 'https://img14.360buyimg.com/imagetools/jfs/t1/272656/24/11147/515/67e4e3e0Fc727ace3/0c5396e2bd111149.png' } }
                                                            />
                                                            <JDText style={ styles.black }>已达开场人数</JDText>
                                                        </View>
                                                        <JDText style={ styles.gray }>可直接出票</JDText>
                                                    </>
                                                )
                                                : (
                                                    <>
                                                        <View style={ [styles.row, styles.mb6] }>
                                                            <JDText type="regular" style={ [styles.red, isAndroid ? { paddingTop: pt(2) } : {}] }> {item?.minTicketNum}</JDText>
                                                            <JDText style={ [styles.black, styles.mr2] }>人开场</JDText>
                                                            {
                                                                item?.joinTicketNum
                                                                    ? (
                                                                        <>
                                                                            <JDText type='regular' style={ [styles.red, isAndroid ? { paddingTop: pt(2) } : {}] }>{item?.joinTicketNum}</JDText>
                                                                            <JDText style={ styles.black }>人已拼</JDText>
                                                                        </>
                                                                    )
                                                                    : null
                                                            }
                                                        </View>
                                                        <JDText style={ styles.gray }>{item?.stopSaleMinute}</JDText>
                                                    </>
                                                )
                                        }

                                    </View>
                                    <View style={ [styles.column, styles.center] }>
                                        <View style={ [styles.row, styles.baseline, styles.mb4] }>
                                            {
                                                item?.jdPrice
                                                    ? (
                                                        <>
                                                            <JDText style={ [styles.red, { paddingBottom: pt(2) }] }>¥</JDText>
                                                            <JDText type='regular' style={ [styles.red, styles.f20] }>{priceQian}</JDText>
                                                            {
                                                                priceHou
                                                                    ? (

                                                                        <JDText type='regular' style={ [styles.red, styles.f14, { paddingBottom: pt(1) }] }>.{priceHou}</JDText>
                                                                    )
                                                                    : null
                                                            }
                                                        </>
                                                    )
                                                    : null
                                            }
                                        </View>
                                        {/** 购票图片 */}
                                        <JDTouchable
                                            onPress={ () => {
                                                goBuy && goBuy(data, item);
                                            } }
                                        >
                                            <JDImage
                                                style={ styles.btn }
                                                source={ { uri: 'https://img13.360buyimg.com/imagetools/jfs/t1/276367/15/10686/9797/67e40c20F99afdd3b/f68fab2b8f21db00.png' } }
                                            />
                                        </JDTouchable>
                                    </View>
                                </View>
                            </View>
                        );
                    })
                }
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        paddingTop: pt(19),
        paddingBottom: pt(19),
        paddingLeft: pt(12),
        // paddingRight: pt(12),
        flexDirection: 'column',
        backgroundColor: '#fff'
    },
    column: {
        flexDirection: 'column'
    },
    start: {
        alignItems: 'flex-start'
    },
    end: {
        alignItems: 'flex-end'
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    addressWrap: {
        flexDirection: 'column',
        marginBottom: pt(12)
    },
    name: {
        fontSize: pt(16),
        fontWeight: '500',
        color: '#222222',
        flex: '1',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
		plan: {
			backgroundColor: '#FFF4E8',
			color: '#A65800',
			padding: pt(2),
			fontSize: pt(11),
			marginBottom: pt(2),
			width: 'fit-content',
			borderRadius: pt(2),
		},
    img: {
        width: pt(4),
        height: pt(9),
        marginLeft: pt(2)
    },
    mb6: {
        marginBottom: pt(6)
    },
    sp: {
        justifyContent: 'space-between'
    },
    gray: {
        fontSize: pt(11),
        color: '#666666'
    },
    planWrap: {
        width: pt(355),
        height: pt(79),
        backgroundColor: '#FAFAFC',
        borderRadius: pt(6),
        paddingTop: pt(18),
        paddingBottom: pt(18),
        paddingLeft: pt(10),
        paddingRight: pt(12),
        marginBottom: pt(12)
    },
    font1: {
        color: '#000',
        fontSize: pt(20)
    },
    font2: {
        color: '#000',
        fontSize: pt(12),
        fontWeight: '500',
        width: pt(80)
    },
    red: {
        fontSize: pt(12),
        color: '#FA2714'
    },
    black: {
        fontSize: pt(12),
        fontWeight: '500',
        color: '#000'
    },
    mr2: {
        marginRight: pt(2)
    },
    center: {
        alignItems: 'center'
    },
    baseline: {
        alignItems: 'flex-end'
    },
    f20: {
        fontSize: pt(20)
    },
    f14: {
        fontSize: pt(14)
    },
    btn: {
        width: pt(53),
        height: pt(25)
    },
    mr25: {
        marginRight: isAndroid ? pt(15) : pt(20)
    },
    mr14: {
        marginRight: pt(10)
    },
    mb4: {
        marginBottom: pt(4)
    },
    img2: {
        width: pt(12),
        height: pt(12),
        marginRight: pt(3)
    },
    pr15: {
        paddingRight: pt(15)
    },
    pr12: {
        paddingRight: pt(12),
        width: '100%',
        overflow: 'hidden'
    },
    tel: {
        width: pt(18),
        height: pt(18),
        marginLeft: pt(8)
    },
    cinema_name_wrap: {
        flex: '1',
        flexDirection: 'row',
        overflow: 'hidden',
    },
    cinema_name: {
        flex: '1',
        flexDirection: 'row',
        overflow: 'hidden',
        maxWidth: pt(310),
    }
});